import { getSettingSelfServeRetailerTaxonomy } from "@faire/help-center-utils/settings/getSettingSelfServeRetailerTaxonomy";
export var BrandDoesNotHaveInsiderFreeShippingIA = function BrandDoesNotHaveInsiderFreeShippingIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHY_BRAND_DOES_NOT_HAVE_INSIDER_FREE_SHIPPING_ANYMORE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [FREE_SHIPPING_COVERAGE_MAY_CHANGE_PERIODICALLY(strictLocalize)];
    }
  };
};
var WHY_BRAND_DOES_NOT_HAVE_INSIDER_FREE_SHIPPING_ANYMORE = function WHY_BRAND_DOES_NOT_HAVE_INSIDER_FREE_SHIPPING_ANYMORE(strictLocalize) {
  return getSettingSelfServeRetailerTaxonomy() ? strictLocalize({
    id: "N937A2",
    defaultMessage: [{
      "type": 0,
      "value": "Uma marca já não tem envio gratuito com Insider"
    }]
  }) : strictLocalize({
    id: "82J7WC",
    defaultMessage: [{
      "type": 0,
      "value": "Porque é que uma marca na qual encomendei anteriormente já não tem envio gratuito com Insider?"
    }]
  });
};
var FREE_SHIPPING_COVERAGE_MAY_CHANGE_PERIODICALLY = function FREE_SHIPPING_COVERAGE_MAY_CHANGE_PERIODICALLY(strictLocalize) {
  return strictLocalize({
    id: "pKpa9D",
    defaultMessage: [{
      "type": 0,
      "value": "As marcas cobertas pelo envio gratuito podem mudar periodicamente. Por exemplo, as marcas cobertas podem mudar quando efetuamos ajustes com base nos custos estimados ou quando testamos novos fatores, como o tipo de relação. Esta flexibilidade permite-nos oferecer envio gratuito no maior número de encomendas possível e manter o preço da subscrição Insider acessível. Embora possa ter tido envio gratuito com Insider na sua última encomenda numa determinada marca, essa marca pode já não estar coberta pelo envio gratuito com Insider da sua subscrição. Se quiser encontrar outras marcas com envio gratuito com Insider, pode usar o filtro Insider enquanto vê artigos ou simplesmente procurar a chave Insider enquanto navega na Faire."
    }]
  });
};